import type { MouseEvent } from 'react'

// Native time inputs hide the browser's own picker icon (index.css), so a click
// anywhere on the field opens the picker instead.
export function openTimePicker(e: MouseEvent<HTMLInputElement>) {
  try {
    e.currentTarget.showPicker()
  } catch {}
}
